import slidesHTML from './slidesHTML';
import thumbsHTML from './thumbsHTML';
import hookedSlidesHTML from '../../../../../src/assets/scripts/hooks/sections/ProductOverview/populateCarousels/slidesHTML';
import hookedThumbsHTML from '../../../../../src/assets/scripts/hooks/sections/ProductOverview/populateCarousels/thumbsHTML';

export default (data, images, id, extras) => {

  let carousel_html = `<div 
  id="${id}" 
  class="ProductImages__carousel"
  data-product-images-carousel
  data-prev-next-buttons="${data.prevNextButtons}"
  data-prev-next-buttons-mobile="${data.prevNextButtonsMobile}"
  data-page-dots="${data.pageDots}"
  data-page-dots-mobile="${data.pageDotsMobile}"
  data-draggable="${data.draggable}"
  data-draggable-mobile="${data.draggableMobile}"
  data-wrap-around="${data.wrapAround}"
  data-wrap-around-mobile="${data.wrapAroundMobile}"
  ${extras ? extras.data : ''}
>
  ${hookedSlidesHTML ? hookedSlidesHTML(images) : slidesHTML(images)}
</div>`;

  // FILMSTRIPS

  if (data.filmstrip || data.filmstripMobile) {
    carousel_html += `<div 
  id="${id}-Thumbs"
  class="ProductImages__thumbs ${data.filmstrip ? 'ProductImages__thumbs--desktop' : ''} ${data.filmstripMobile ? 'ProductImages__thumbs--mobile' : ''}"
  data-product-images-thumbs
  data-as-nav-for="#${id}"
  data-draggable="${data.filmstripDraggable}"
  data-draggable-mobile="${data.filmstripDraggableMobile}"
  data-cell-align="${data.filmstripCellAlign}"
  data-cell-align-mobile="${data.filmstripCellAlignMobile}"
  data-prev-next-buttons="${data.filmstripPrevNextButtons}"  
  data-prev-next-buttons-mobile="${data.filmstripPrevNextButtonsMobile}"
>
  ${hookedThumbsHTML ? hookedThumbsHTML(images) : thumbsHTML(images)}
</div>`;
  }

  return carousel_html;
};